import { IDataModal } from "../..";
import { ComplexAnimatedModal } from "../../../../ui/modal/ComplexAnimatedModal";
import styles from "./styles.module.scss";
import { useEffect, useState } from "react";
import useDealRequest, {
  EDealRequestType,
  TCommonWizardsSchema,
} from "../../../../../api/hooks/use-deal-request";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import AuthModal from "../../../auth/components/modals/authModal";
import { PATHS } from "../../../../shared/constants";
import FormRequest from "../forms/formRequest/formRequest";
import { EMarketTypes } from "../../../../../interfaces";
import localStorageServices from "../../../../../lib/services/localStorage.service";
import useOpenModal from "../../../../ui/modal/hooks/useOpenModal";
interface IModalSupportDealProps {
  isOpen: boolean;
  onDismiss: (value: boolean) => void;
  onAllReset?: () => void;
  marketType: EMarketTypes;
  data: IDataModal;
  offsetY: number;
  title?: string;
  type?: "service" | "support";
}
export interface IDataSupport {
  buildingId: number;
  facilityTypeId?: number;
  areaInSqM: string;
  address: string;
  complexId?: number;
  streetId?: number;
}

const TEXT = `Отправьте заявку и мы отправим вам экспертный расчет рыночной стоимости в течении 2х рабочих дней.`;

const ModalSupportDeal = ({
  isOpen,
  data,
  onDismiss,
  onAllReset,
  marketType,
  offsetY,
}: IModalSupportDealProps) => {
  const navigate = useNavigate();

  const initDataSupport: IDataSupport = {
    buildingId: data.buildingId ?? -1,
    facilityTypeId: data.facilityTypeId,
    areaInSqM: data.areaInSqM ?? "",
    address: data.address ?? "",
    complexId: data.complexId,
    streetId: data.streetId,
  };

  const [dataSupport, setDataSupport] = useState<IDataSupport>(initDataSupport);

  const onChangeData = (value: string, key: string) => {
    setDataSupport((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    setDataSupport((prev) => ({
      ...prev,
      address: data.address ?? "",
      apartmentType: data.typeApartment,
      areaInSqM: data.areaInSqM ?? "",
      complexId: data.complexId,
      streetId: data.streetId,
    }));
  }, [data]);

  useEffect(() => {
    setDataSupport(initDataSupport);
  }, [isOpen]);

  const { error, isMutating, trigger } = useDealRequest();

  const {
    offsetY: offsetYAuth,
    open: openAuth,
    handleChangeModal: handleChangeModalAuth,
  } = useOpenModal();

  const handleSubmit = async () => {
    if (localStorageServices.getAccessToken()) {
      try {
        await trigger({
          marketType: marketType,
          type: EDealRequestType.Estimate,
          data: {
            buildingId: dataSupport.buildingId,
            areaInSqM: Number(dataSupport.areaInSqM),
            typeId: dataSupport.facilityTypeId,
            complexId: dataSupport.complexId,
            streetId: dataSupport.streetId,
          } as Partial<TCommonWizardsSchema>,
        });
        toast.success(
          "Ваша заявка принята, наш эксперт свяжется с вами в течении 2х часов в рабочее время."
        );
        onAllReset && onAllReset();
        onDismiss(false);
        navigate(`/${PATHS.myPersonal}`);
      } catch (error: any) {
        if (error.message === "Unauthorized") {
          handleChangeModalAuth(true);
        }
      }
    } else {
      handleChangeModalAuth(true);
    }
  };

  return (
    <div>
      {openAuth && (
        <AuthModal
          opened={openAuth}
          onClose={() => handleChangeModalAuth(false)}
          offsetY={offsetYAuth}
        />
      )}
      <ComplexAnimatedModal
        offsetY={offsetY}
        opened={isOpen}
        onClose={() => onDismiss(false)}
      >
        <div className={styles.commonModalContainer}>
          <FormRequest
            title={"Сервис оцернки жилья"}
            text={TEXT}
            buttonLabel="Обратиться в Reit"
            onClick={handleSubmit}
            data={dataSupport}
            onChange={onChangeData}
            isLoading={isMutating}
            type="default"
          />
        </div>
      </ComplexAnimatedModal>
    </div>
  );
};

export default ModalSupportDeal;
